module.exports = __webpack_public_path__ + "static/media/DINOT-Bold.3421fddb.woff2";